import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

const HARDCODED = [
	{ label: "Madrasah", value: 4500, suffix: "+" },
	{ label: "Sekolah Terpasang", value: 900, suffix: "+" },
	{ label: "Siswa Aktif", value: 45400, suffix: "+" },
];

function StatsCounter() {
	const [isVisible, setIsVisible] = useState(false);
	const [stats, setStats] = useState(HARDCODED);
	const [counts, setCounts] = useState(HARDCODED.map(() => 0));
	const sectionRef = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting && !isVisible) setIsVisible(true);
			},
			{ threshold: 0.3 }
		);
		if (sectionRef.current) observer.observe(sectionRef.current);
		return () => observer.disconnect();
	}, [isVisible]);

	useEffect(() => {
		axios
			.get("/api_w/abouts", {
				params: { title: "home:stats" },
				headers: { db_name: process.env.REACT_APP_DB_NAME },
			})
			.then((res) => {
				const item = res.data.data?.[0];
				if (item?.body) {
					const parsed = JSON.parse(item.body);
					if (parsed?.items) setStats(parsed.items);
				}
			})
			.catch(() => {});
	}, []);

	useEffect(() => {
		if (!isVisible) return;
		stats.forEach((stat, idx) => {
			let start = 0;
			const end = stat.value;
			const duration = 2000;
			const stepTime = Math.max(
				Math.floor(duration / (end / (end > 1000 ? 50 : 10))),
				20
			);
			const increment = Math.ceil(end / (duration / stepTime));

			const timer = setInterval(() => {
				start += increment;
				if (start >= end) {
					start = end;
					clearInterval(timer);
				}
				setCounts((prev) => {
					const newCounts = [...prev];
					newCounts[idx] = start;
					return newCounts;
				});
			}, stepTime);
		});
	}, [isVisible, stats]);

	const formatNumber = (num, stat) => {
		if (num >= stat.value) {
			if (stat.value >= 1000) return (stat.value / 1000).toFixed(1) + "K";
			return stat.value.toString();
		}
		if (num >= 1000) return (num / 1000).toFixed(1) + "K";
		return num.toString();
	};

	return (
		<section aria-label="Statistik"
			ref={sectionRef}
			className="w-full bg-green-700 py-12 relative overflow-hidden"
		>
			<div className="max-w-8xl mx-auto px-4 relative z-10">
				<div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-4">
					{stats.map((stat, idx) => (
						<div
							key={stat.label}
							className={`text-center text-white transition-all duration-700 ${isVisible ? "animate-fade-in opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}
							style={{ animationDelay: `${idx * 0.2}s` }}
						>
							<h3 className="text-4xl md:text-5xl font-bold mb-1">
								{formatNumber(counts[idx], stat)}
								{stat.suffix}
							</h3>
							<p className="text-green-100 font-medium text-sm md:text-base opacity-80">
								{stat.label}
							</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}

export default StatsCounter;
